export default __webpack_public_path__ + "static/media/banner.2f2587a4.jpg";